export const apiBase = import.meta.env.VITE_PCK_API_BASE_DEV
    ?? import.meta.env.VITE_PCK_API_BASE
    ?? 'http://localhost:8080'
